const STORAGE_KEY = 'civixthread:verifiedVotesOnly';

/**
 * Whether bill like/dislike counts should only include verified users' votes.
 * Persisted so Bills list and Bill detail stay in sync (matches mobile AsyncStorage key concept).
 */
export function getVerifiedVotesOnly() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setVerifiedVotesOnly(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // Non-fatal: filter still applies for the current session.
  }
}
